<template lang="html">
    <div ref="shadowingModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
            <div class="modal-content" style="max-height:30rem;">
                <div class="modal-header text-dark">
                    <h5 class="modal-title" id="exampleModalLabel">跟讀小幫手</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-dark">
                    <h5 v-if="shadowingCaption !== null">{{shadowingCaption.Text}}</h5>
                    <br />
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-action" style="text-align: left;padding-left: 0.25rem;" v-for="r in recordingData.slice().reverse()" :key="r.url">
                            <a :download="r.download" :href="r.url" style="color: #007bff;">{{r.text}}</a>
                            <br />
                            <audio controls="controls" :src="r.url"></audio>
                            <br />

                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" :disabled="isRecording" class="btn btn-primary" v-on:click="doPlaySampleSentence();">撥放例句</button>
                    <button id="record-button" type="button" :disabled="isPlayingSampleSentence||!isRecorderReady" class="btn btn-primary" v-on:click="doRecord();">
                        {{ recordBtnText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
    import Recorder from 'recorder-core'

    //需要使用到的音频格式编码引擎的js文件统统加载进来
    import 'recorder-core/src/engine/mp3'
    import 'recorder-core/src/engine/mp3-engine'

    //import 'recorder-core/src/engine/wav'

    export default {
        data: function() {
            return {
                // outbinding
                yyPlayer: null,

                // shadowing variables
                recorder: null,
                isRecorderReady: false,
                isRecording: false,
                isPlayingSampleSentence: false,
                recordBtnText: '開始錄音',
                recordingData: [],
                shadowingCaption: null,
                shadowingCaptionIndex: null,
            };
        },
        methods: {
            alert: function (msg) {
                this.$modal.show("dialog", {
                    title: "請注意",
                    text: msg,
                    buttons: [{
                        title: "關閉",
                    },],
                });
            },
            open: function (player, cap, capIdx) {
                this.yyPlayer = player;
                this.shadowingCaption = cap;
                this.shadowingCaptionIndex = capIdx;

                if (!this.recorder) {
                    this.recorder = Recorder({
                        type: 'mp3',
                        sampleRate: 44100,
                        bitRate: 32
                    });
                }
                var self = this;
                this.recorder.open(
                    function () {
                        self.isRecorderReady = true;
                    }, function (msg, isUserNotAllow) {
                        if (isUserNotAllow) {
                            alert('需要取得您的允許才可以錄音喔!');
                        } else {
                            alert('無法支援錄音，請注意需要使用瀏覽器開啟方可使用錄音!');
                        }
                    }
                );

                $(this.$refs.shadowingModal).modal();
                //$('#'+this.id).modal();
            },
            doRecord: function () {
                if (this.isPlayingSampleSentence) { return; }

                this.isRecording = !this.isRecording;
                if (this.isRecording) {
                    this.recordBtnText = '停止錄音';
                    this.startRecord();
                } else {
                    this.recordBtnText = '開始錄音';
                    this.stopRecord();
                }
            },
            startRecord: function () {
                if (this.isRecorderReady) {
                    this.recorder.start();//开始录音
                }
            },
            stopRecord: function () {
                if (this.isRecorderReady && this.recorder.state) {
                    var self = this;
                    this.recorder.stop(
                        function (blob) {
                            self.createDownloadLink(blob);
                            self.isRecording = false;
                        }, function (errorMsg) {
                            self.alert('錄音時發生錯誤。錯誤訊息: ' + errorMsg);
                            self.isRecording = false;
                        }
                    );
                }
            },
            stopSamplePlaying: function () {
                this.yyPlayer.pauseVideo();
                this.isPlayingSampleSentence = false;
            },
            doPlaySampleSentence: function () {
                if (this.isRecording) { return; }

                this.isPlayingSampleSentence = true;
                this.yyPlayer.playCaptionSingle(this.shadowingCaption);
            },
            createDownloadLink: function (blob) {
                var url = URL.createObjectURL(blob);

                var newRec = {
                    url: url,
                    text: this.shadowingCaption.Text,
                    download: new Date().toISOString() + '.wav',
                };
                this.recordingData.push(newRec);
            },
            onShadowingWindowShow: function () {
                console.log('onShadowingWindowShow is called');
            },
            onShadowingWindowHide: function () {
                this.stopSamplePlaying();
                this.stopRecord();

                // clear the recorder
                if (this.recorder) {
                    this.recorder.close();
                    this.recorder = null;
                    this.isRecorderReady = false;
                }
            },
            onVideoSingleplayEnd: function () {
                this.isPlayingSampleSentence = false;
            }
        },
        mounted() {
            this.id = this._uid;
            this.$eventBus.$on('video-singleplay-end', this.onVideoSingleplayEnd);

            $(this.$refs.shadowingModal).on("show.bs.modal", this.onShadowingWindowShow);
            $(this.$refs.shadowingModal).on("hide.bs.modal", this.onShadowingWindowHide);
        },
    };
</script>
    
<style lang="css">
</style>